import { RequestService } from '../../../../../common/services/RequestService';
import { MODELS_BY_BRAND_GET } from '../../constants';

export const getModelsByBrandRequest = payload => {
  return RequestService.get(`${MODELS_BY_BRAND_GET}${payload}`);
};
